module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-HIPPO-Pet.a93070e7.gif";